module.exports = {
  "country": "BG",
  "artist": "Poli Genova",
  "song": "If Love was a Crime",
  "year": "2016",
  "place": "4",
  "spotify": "1G5qDCiqei7ozj5ku43TuR"
};